<script lang="ts">
  import mobile from "is-mobile";
  import { afterUpdate } from "svelte";
  import Scene from "./components/Scene.svelte";
  import {
    isDragging,
    isScrolling,
    selectedActivityIndex,
    urlParams,
    isOtherActivitiesWindowOpen,
    selectedOtherActivity,
  } from "./store/AppState";
  import ModalWindow from "./components/ModalWindow.svelte";
  import OtherActivitiesWindow from "./components/OtherActivitiesWindow.svelte";

  const isTablet = mobile({ tablet: true, featureDetect: true });

  //TODO: Extract Controls component
  let arrowLeftActive: boolean = false;
  let arrowRightActive: boolean = false;

  let sliderElement: HTMLElement;

  const stepRight = () => {
    window.requestAnimationFrame(() => {
      sliderElement.scrollLeft += 10;
      if (
        sliderElement.scrollWidth - sliderElement.clientWidth <=
        sliderElement.scrollLeft
      ) {
        arrowRightActive = false;
        isScrolling.set(false);
      }
    });
  };

  const stepLeft = () => {
    window.requestAnimationFrame(() => {
      sliderElement.scrollLeft -= 10;
      if (sliderElement.scrollLeft <= 0) {
        arrowLeftActive = false;
        isScrolling.set(false);
      }
    });
  };

  const autoScroll = (e: MouseEvent) => {
    const pageYPercentage = (e.pageY / sliderElement.clientHeight) * 100;
    let isAboveOrBelowScrollArea = pageYPercentage < 25 || pageYPercentage > 75;
    if (window.isClosed && !window.isShowroom) {
      isAboveOrBelowScrollArea = pageYPercentage < 25;
    }
    if (isTablet || isAboveOrBelowScrollArea) {
      arrowLeftActive = false;
      arrowRightActive = false;
      isScrolling.set(false);
      return;
    }
    if ($selectedActivityIndex !== null || $isOtherActivitiesWindowOpen) {
      return;
    }
    if (
      e.pageX > sliderElement.clientWidth / 1.2 &&
      !isAboveOrBelowScrollArea
    ) {
      if (
        sliderElement.scrollLeft >=
        sliderElement.scrollWidth - sliderElement.clientWidth
      ) {
        arrowRightActive = false;
        isScrolling.set(false);
      } else {
        arrowRightActive = true;
      }
    }
    if (e.pageX < sliderElement.clientWidth / 5 && !isAboveOrBelowScrollArea) {
      if (sliderElement.scrollLeft <= 0) {
        arrowLeftActive = false;
        isScrolling.set(false);
      } else {
        arrowLeftActive = true;
      }
    }
    if (
      (e.pageX >= sliderElement.clientWidth / 5 &&
        e.pageX <= sliderElement.clientWidth / 1.2) ||
      isAboveOrBelowScrollArea
    ) {
      arrowLeftActive = false;
      arrowRightActive = false;
      isScrolling.set(false);
    }
  };

  let isPointerDown = false;
  let startX: number;
  let scrollLeft: number;

  const handlePointerDown = (e: TouchEvent) => {
    if ($isOtherActivitiesWindowOpen) {
      return;
    }
    if (isTablet) {
      isPointerDown = true;
      startX = e.changedTouches[0].pageX - sliderElement.offsetLeft;
      scrollLeft = sliderElement.scrollLeft;
    }
  };

  const handlePointerMove = (e: TouchEvent) => {
    if ($isOtherActivitiesWindowOpen) {
      return;
    }
    if (isTablet) {
      if (isPointerDown) {
        e.preventDefault();
        isDragging.set(true);
        const x = e.changedTouches[0].pageX - sliderElement.offsetLeft;
        const walk = (x - startX) * 1;
        sliderElement.scrollLeft = scrollLeft - walk;
      }
    }
  };

  const handlePointerUp = (e: TouchEvent) => {
    if ($isOtherActivitiesWindowOpen) {
      return;
    }
    if ($isDragging) {
      e.preventDefault();
    }
    if (isTablet) {
      isDragging.set(false);
      isPointerDown = false;
    }
  };

  afterUpdate(() => {
    if (arrowLeftActive) {
      isScrolling.set(true);
      stepLeft();
    } else if (arrowRightActive) {
      isScrolling.set(true);
      stepRight();
    } else {
      isScrolling.set(false);
    }
  });
</script>

<main
  on:mouseover={autoScroll}
  on:contextmenu={() => false}
  on:touchstart={(e) => handlePointerDown(e)}
  on:touchend={(e) => handlePointerUp(e)}
  on:touchmove={(e) => handlePointerMove(e)}
  on:focus={() => {}}
  bind:this={sliderElement}
  class="app"
  style={`--height: ${
    __MODE__ === "production" ? "calc(100dvh - 6.4rem)" : "100dvh"
  }`}
>
  {#if $selectedActivityIndex === null && !$isOtherActivitiesWindowOpen}
    <div role="navigation" class="arrow-container arrow-left">
      <img
        class="arrow"
        style={`--opacity: ${arrowLeftActive ? "100%" : "80%"}; --scale: ${
          arrowLeftActive ? "1.1" : "1"
        }`}
        src={`${__PUBLIC_PATH__}images/ArrowLeft.png`}
        alt="arrowLeft"
      />
    </div>
  {/if}
  <Scene />
  {#if $selectedActivityIndex === null && !$isOtherActivitiesWindowOpen}
    <div role="navigation" class="arrow-container arrow-right">
      <img
        class="arrow"
        style={`--opacity: ${arrowRightActive ? "100%" : "80%"}; --scale: ${
          arrowRightActive ? "1.1" : "1"
        }`}
        src={`${__PUBLIC_PATH__}images/ArrowRight.png`}
        alt="arrowRight"
      />
    </div>
  {/if}
  {#if $urlParams.has("aktivita") && $selectedActivityIndex !== null}
    <ModalWindow />
  {/if}
  {#if ($urlParams.has("aktivita") && $selectedOtherActivity !== null) || $isOtherActivitiesWindowOpen}
    <OtherActivitiesWindow />
  {/if}
</main>

<style>
  .app {
    overflow: hidden;
    text-align: center;
    height: var(--height);
    max-width: 100vw;
  }

  .arrow-container {
    height: 50%;
    width: 9.6rem;
    position: absolute;
    z-index: 10000;
    top: 25%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    pointer-events: none;
  }

  .arrow {
    width: 5vmin;
    height: 8vmin;
    opacity: var(--opacity);
    transform: scale(var(--scale));
  }
  .arrow-left {
    left: 2%;
    align-items: flex-start;
  }
  .arrow-right {
    right: 2%;
    align-items: flex-end;
  }
</style>
